import React, { useContext } from 'react';
import NumberFormat from 'react-number-format';

// @material-ui/core components
// import { withStyles, makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
// import Slider from '@material-ui/core/Slider';
// import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

// mobx components
import { observer } from 'mobx-react';
import GoalStoreContext from '../../stores/GoalStore';

// core components
import CustomSlider from '../CustomSlider/CustomSlider';
import CustomInput from '../CustomInput/CustomInput';

// function ValueLabelComponent(props) {
//   const { children, open, value } = props;

//   const popperRef = React.useRef(null);
//   React.useEffect(() => {
//     if (popperRef.current) {
//       popperRef.current.update();
//     }
//   });

//   return (
//     <Tooltip
//       PopperProps={{
//         popperRef,
//       }}
//       open={open}
//       enterTouchDelay={0}
//       placement="top"
//       title={value}
//     >
//       {children}
//     </Tooltip>
//   );
// }

const Goal = observer(props => {
  const goalStore = useContext(GoalStoreContext);

  const { goal, lang } = props;
  // const [detail, setDetail] = useState({
  //   description: null,
  //   amount: 1000,
  //   years: 1,
  // });

  // const handleSliderObjectiveChange = name => (event, value) => {
  //   setDetail({
  //     ...detail,
  //     [name]: value,
  //   });
  // };

  const handleSlideValueAmount = value => {
    goalStore.setDetailGoal(goal.value, 'amount', value);
  };

  const handleSlideValueYears = value => {
    goalStore.setDetailGoal(goal.value, 'years', value);
  };

  const handleChangeText = name => event => {
    goalStore.setDetailGoal(goal.value, name, event.target.value);
  };

  return (
    <div
      style={{
        paddingTop: '10px',
        paddingBottom: '10px',
        paddingLeft: '20px',
        // border: '1px solid #dbdbdb',
        backgroundColor: '#f4f4f4e8',
        paddingRight: '20px',
      }}
    >
      <div>
        <p
          style={{
            color: '#000',
            fontSize: '20px',
            lineHeight: '135%',
            width: '100%',
            wordBreak: 'break-word',
            margin: '0px',
            fontWeight: '600',
          }}
        >
          {lang.goalDescription}
        </p>

        <TextField
          id="nameTxt"
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          placeholder={lang.goalPlaceHolder}
          onChange={handleChangeText('description')}
          value={goalStore.goals.find(x => x.name === goal.value).description}
        />
      </div>
      <br />
      <div>
        <Typography gutterBottom>
          {lang.goalAmountSaving}{' '}
          <span
            style={{
              color: '#000',
              fontSize: '18px',
              lineHeight: '135%',
              width: '100%',
              wordBreak: 'break-word',
              margin: '0px',
              fontWeight: '600',
            }}
          >
            <NumberFormat
              value={goalStore.goals.find(x => x.name === goal.value).amount}
              displayType="text"
              thousandSeparator
              prefix="$"
            />
          </span>
        </Typography>

        <CustomInput
          defaultValue={goalStore.goals.find(x => x.name === goal.value).amount}
          handleChangeValue={handleSlideValueAmount}
        />
        {/* <CustomSlider
          defaultValue={goalStore.goals.find(x => x.name === goal.value).amount}
          handleChangeValue={handleSlideValueAmount}
        /> */}
      </div>
      <br />

      <div>
        <Typography gutterBottom>
          {lang.goalTime}{' '}
          <span
            style={{
              color: '#000',
              fontSize: '18px',
              lineHeight: '135%',
              width: '100%',
              wordBreak: 'break-word',
              margin: '0px',
              fontWeight: '600',
            }}
          >
            {goalStore.goals.find(x => x.name === goal.value).years} años
          </span>
        </Typography>

        <CustomSlider
          defaultValue={goalStore.goals.find(x => x.name === goal.value).years}
          min={1}
          step={1}
          max={80}
          handleChangeValue={handleSlideValueYears}
        />
      </div>
    </div>
  );
});

export default Goal;
